import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Modules() {
  const modules = [{
    icon: '📘',
    title: 'Tomo 1 — Línea Herrero · Descuentos Maestros',
    desc: 'Tablas de descuento para todas las tipologías. Marco, hoja y vidrio. Sin calcular de cabeza.'
  }, {
    icon: '📗',
    title: 'Tomo 2 — Línea Módena · Alta Gama',
    desc: 'Descuentos exactos para trabajos premium. DVH, bisagras ocultas, puertas de alta gama.'
  }, {
    icon: '📙',
    title: 'Tomo 3 — Guía Visual de Armado',
    desc: 'Secuencias de fabricación paso a paso. El orden correcto para cada tipología.'
  }, {
    icon: '📕',
    title: 'Tomo 4 — Mecanizados y Punzonados',
    desc: 'Medidas exactas para ruedas, bisagras, fallebas y cerraduras. Cero errores de calado.'
  }, {
    icon: '📓',
    title: 'Tomo 5 — Protocolo de Instalación en Obra',
    desc: 'Nivelación en 3 ejes. Sellado en 4 capas. Checklist de 30 puntos antes de retirarte.'
  }, {
    icon: '📔',
    title: 'Tomo 6 — Calculador de Presupuestos y Rentabilidad',
    desc: 'Los 6 componentes del costo real. Precio de venta con margen garantizado. Punto de equilibrio mensual.'
  }];
  const includes = ['Tablas listas para imprimir', 'Protocolos paso a paso', 'Checklists de verificación', 'Printable A4 para el banco'];
  return <section className="py-12 bg-surface border-y border-white/5" data-id="element-175">
      <div className="container mx-auto px-4" data-id="element-176">
        <FadeIn data-id="element-177">
          <div className="text-center mb-10" data-id="element-178">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 mb-4 rounded-full border border-gold/40 bg-gold/10" data-id="element-179">
              <span className="text-gold text-sm md:text-base font-bold uppercase tracking-wider" data-id="element-180">
                Esto es lo que vas a recibir
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold mb-4 leading-tight" data-id="element-181">
              Todo lo que necesitás para{' '}
              <span className="text-gold" data-id="element-182">
                cotizar, fabricar e instalar sin improvisar
              </span>
            </h2>
            <p className="text-base md:text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-183">
              6 tomos prácticos, listos para imprimir y usar en el taller para
              reducir errores, ahorrar tiempo y trabajar con margen real.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10" data-id="element-184">
          {modules.map((mod, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-185">
              <div className="bg-background p-6 rounded-2xl border border-white/10 hover:border-gold/50 transition-colors group h-full" data-id="element-186">
                <div className="text-4xl mb-4 group-hover:scale-110 transition-transform origin-left" data-id="element-187">
                  {mod.icon}
                </div>
                <h3 className="text-lg font-bold mb-2 text-white leading-tight" data-id="element-188">
                  {mod.title}
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-189">{mod.desc}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-190">
          <div className="bg-background/50 p-8 rounded-2xl border border-white/5 max-w-4xl mx-auto" data-id="element-191">
            <h4 className="text-center text-lg text-gray-300 mb-6 font-medium" data-id="element-192">
              Cada tomo incluye:
            </h4>
            <div className="grid sm:grid-cols-2 gap-4" data-id="element-193">
              {includes.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-194">
                  <CheckCircle2 className="w-5 h-5 text-gold shrink-0" data-id="element-195" />
                  <span className="text-gray-200" data-id="element-196">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}